












































import Component from 'vue-class-component';
import { Prop, Vue } from 'vue-property-decorator';
import HuntingLicense = Orders.HuntingLicense;

@Component({
  name: 'HuntingLicense',
})
export default class HuntingLicenseComponent extends Vue {
  @Prop({ required: true, type: Object })
  license!: HuntingLicense;

  get licenseIssuer(): string {
    return `${this.license.user?.lastName} ${this.license.user?.firstName} ${this.license.user?.middleName}`;
  }
};
